import { StackedBar } from '@factorialco/deprecated-design-system'
import { EmployeeTimePeriodDetailsFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { ZERO_HOURS } from 'modules/shift_management/components/ShiftManagement/TimeInsightsSidepanel/Content/utils'
import { nameFromHexCode } from 'modules/shift_management/lib/colors'

import StackedBarsTooltip from './StackedBarsTooltip'
import { convertHoursBars, hoursBars } from './utils'

export interface Props {
  employeeData: EmployeeTimePeriodDetailsFragment
  rangeType: string
  convertHours: boolean
}

const HoursStackedBars = ({ employeeData, rangeType, convertHours }: Props) => {
  const { plannedHours, paidLeavesHours, overplannedHours } = employeeData
  const noPlannedData =
    plannedHours === ZERO_HOURS && paidLeavesHours === ZERO_HOURS && overplannedHours === ZERO_HOURS

  const data = convertHours
    ? convertHoursBars(employeeData, rangeType)
    : hoursBars(employeeData, rangeType)

  const sortedByHourType = data.bars.sort((a, b) => {
    return a.hoursType - b.hoursType
  })

  return (
    <StackedBar>
      {noPlannedData ? (
        <StackedBar.Bar
          value={100}
          color={[nameFromHexCode('grey400'), nameFromHexCode('grey200')]}
          label={
            <StackedBarsTooltip
              color={nameFromHexCode('grey400')}
              hours={data.remainingHours}
              rangeType={rangeType}
            />
          }
        />
      ) : (
        sortedByHourType.map((bar) => (
          <StackedBar.Bar
            key={bar.hoursType}
            value={bar.hours}
            label={bar.label}
            color={bar.color}
          />
        ))
      )}
    </StackedBar>
  )
}

export default observer(HoursStackedBars)
